// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IPlanSummaryDto
 */
export interface IPlanSummaryDto {
    /**
     * 
     * @type {string}
     * @memberof IPlanSummaryDto
     */
    plan_code?: string;
    /**
     * 
     * @type {number}
     * @memberof IPlanSummaryDto
     */
    recipients_count?: number;
    /**
     * 
     * @type {number}
     * @memberof IPlanSummaryDto
     */
    forecasted_amount?: number;
}

/**
 * Check if a given object implements the IPlanSummaryDto interface.
 */
export function instanceOfIPlanSummaryDto(value: object): value is IPlanSummaryDto {
    return true;
}

export function IPlanSummaryDtoFromJSON(json: any): IPlanSummaryDto {
    return IPlanSummaryDtoFromJSONTyped(json, false);
}

export function IPlanSummaryDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IPlanSummaryDto {
    if (json == null) {
        return json;
    }
    return {
        
        'plan_code': json['plan_code'] == null ? undefined : json['plan_code'],
        'recipients_count': json['recipients_count'] == null ? undefined : json['recipients_count'],
        'forecasted_amount': json['forecasted_amount'] == null ? undefined : json['forecasted_amount'],
    };
}

export function IPlanSummaryDtoToJSON(json: any): IPlanSummaryDto {
    return IPlanSummaryDtoToJSONTyped(json, false);
}

export function IPlanSummaryDtoToJSONTyped(value?: IPlanSummaryDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'plan_code': value['plan_code'],
        'recipients_count': value['recipients_count'],
        'forecasted_amount': value['forecasted_amount'],
    };
}

